import { showPopup } from "./popup";
import InfoIcon from '@mui/icons-material/Info';
import SuccessIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button } from "@mui/joy";
import { getI18n } from "react-i18next";

const t = getI18n().t;

export const handlePopup = (type = 'unknown', message, action) => {
  switch (type) {
    case "info":
      showPopup(getInfoModal(message, action));
      break;
    case "error":
      showPopup(getErrorModal(message, action));
      break;
    case "success":
      showPopup(getSuccessModal(message, action));
      break;
    default:
      showPopup(getInfoModal(message, action));
      break;
  }
};

function getInfoModal(message, customActions){
  const actions = customActions ? customActions : (closePopup) => (
    <Button 
      variant="solid" 
      color="primary" 
      onClick={() => {
        closePopup();
      }}
    >
      {t('ok')}
    </Button>
  );
  return {
    title: t('info'),
    titleIcon: <InfoIcon sx={{color: 'var(--joy-palette-info-500)'}} />,
    content: message,
    actions
  }
}
function getErrorModal(message, customActions){
  const actions = customActions ? customActions : (closePopup) => (
    <Button 
      variant="solid" 
      color="primary" 
      onClick={() => {
        closePopup();
      }}
    >
      {t('ok')}
    </Button>
  );
  return {
    title: t('error'),
    titleIcon: <ErrorOutlineIcon sx={{color: 'var(--joy-palette-danger-500)'}} />,
    content: message,
    actions
  }
}

function getSuccessModal(message, customActions){
  const actions = customActions ? customActions : (closePopup) => (
    <Button 
      variant="solid" 
      color="primary" 
      onClick={() => {
        closePopup();
      }}
    >
      {t('ok')}
    </Button>
  );
  return {
    title: t('success'),
    titleIcon: <SuccessIcon sx={{color: 'var(--joy-palette-success-500)'}} />,
    content: message,
    actions
  }
}

export class AppError extends Error {
  constructor(type, message) {
    super(message);
    this.type = type;
    this.name = 'AppError';
    this.message = message;
  }

}